__turbopack_context__.v({
  "align-center": "text-module__x9KajG__align-center",
  "align-justify": "text-module__x9KajG__align-justify",
  "align-left": "text-module__x9KajG__align-left",
  "align-right": "text-module__x9KajG__align-right",
  "bold": "text-module__x9KajG__bold",
  "italic": "text-module__x9KajG__italic",
  "size-l": "text-module__x9KajG__size-l",
  "size-m": "text-module__x9KajG__size-m",
  "size-s": "text-module__x9KajG__size-s",
  "size-xs": "text-module__x9KajG__size-xs",
  "spacing": "text-module__x9KajG__spacing",
  "text": "text-module__x9KajG__text",
});
